import React, {useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {SuccessDialog} from 'components/Shared/Dialogs/SuccessDialog'
import {useErrorHandling} from 'context/errorHandling'
import {INITIAL_VALUES, toFormValues} from 'components/Contractors/InsurancePolicy/Form/form'
import {fetchInsurancePolicy, updateInsurancePolicy} from 'services/InsurancePolicyService'
import {InsurancePolicyForm} from 'components/Contractors/InsurancePolicy/Form/InsurancePolicyForm'
import {useNavigatePrevent} from 'context/navigatePrevent'
import {POLICY_CONFIRMATION_FILE_TYPE, POLICY_FILE_TYPE} from "../constants";

export function EditInsurancePolicyForm(props) {
  const contractorId = props.match.params.contractorId
  const policyId = props.match.params.policyId

  const [policy, setPolicy] = useState()
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const {handleError} = useErrorHandling()
  const {t} = useTranslation()
  const {setNavigationUnlocked} = useNavigatePrevent()

  const [initialPolicyFiles, setInitialPolicyFiles] = useState([])
  const [initialConfirmationFiles, setInitialConfirmationFiles] = useState([])


  const initialValues = useMemo(() => policy ? toFormValues(policy) : INITIAL_VALUES, [policy])

  useEffect(() => {
      setLoading(true)
      fetchInsurancePolicy(policyId)
        .then(setPolicy)
        .catch(error => handleError(error))
        .then(() => setLoading(false))
    }, [policyId, handleError]
  )

  useEffect(() => {
      // TODO: cleanup
      setInitialPolicyFiles(policy?.files.filter(file => file.type === POLICY_FILE_TYPE) || [])
      setInitialConfirmationFiles(policy?.files.filter(file => file.type === POLICY_CONFIRMATION_FILE_TYPE) || [])
      // setInitialPolicyFiles(policy?.files || [])
      // setInitialConfirmationFiles(policy?.files || [])
    }, [policy, setInitialPolicyFiles, setInitialConfirmationFiles]
  )

  const handleSubmit = (values, onSuccess) => {
    setLoading(true)
    updateInsurancePolicy(policyId, {contractorId, ...values})
      .then(() => onSuccess(policyId)
        .then(() => setSuccessDialogOpen(true))
        .catch(handleError)
      )
      .catch(handleError)
      .then(() => setLoading(false))
  }

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    setNavigationUnlocked(history => history.push(`/contractors/details/${contractorId}`))
  }

  return (
    <>
      <SuccessDialog
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
        content="insurancePolicy.form.edit.successMessage"/>
      <InsurancePolicyForm
        title={t('insurancePolicy.form.edit.title')}
        initialValues={initialValues}
        initialPolicyFiles={initialPolicyFiles}
        initialConfirmationFiles={initialConfirmationFiles}
        onSubmit={handleSubmit}
        loading={loading}
        entityId={policyId}
      />
    </>
  )
}
